/** Ask page (EN source of truth + VI); spread into the main dictionaries */

export const askEn = {
  'nav.ask': 'Ask',
  'ask.title': 'Ask the wiki',
  'ask.subtitle': 'Answers come only from this project\'s wiki, documents you can read, and its Sources, with a citation on every claim. When the wiki does not say, you are told so instead of a guess.',
  'ask.label': 'Question',
  'ask.placeholder': 'How do deploys work?',
  'ask.submit': 'Ask for {credits} credits',
  'ask.asking': 'Asking…',
  'ask.cost': 'Uses your AI provider. {credits} credits per answer; nothing when the wiki has no answer or the provider fails.',
  'ask.failed': 'Could not ask: {message}',
  'ask.notFound': 'The wiki does not contain the answer.',
  'ask.notFoundHint': 'Nothing was charged. Push a Source that answers it, then compile; the question is listed under Health.',
  'ask.providerFailed': 'The AI provider failed: {message}. Nothing was charged.',
  'ask.citations': 'Cited',
  'ask.kind.wiki': 'Wiki',
  'ask.kind.source': 'Source',
  'ask.kind.document': 'Document',
  'ask.charged': '{credits} credits charged',
  'ask.needsEditor': 'Asking spends workspace credits, so only editors and admins can ask.',
}

export const askVi: Record<keyof typeof askEn, string> = {
  'nav.ask': 'Hỏi',
  'ask.title': 'Hỏi wiki',
  'ask.subtitle': 'Câu trả lời chỉ lấy từ wiki của dự án, tài liệu bạn được xem và các Nguồn, mỗi ý đều có trích dẫn. Khi wiki không có thông tin, bạn sẽ được báo như vậy thay vì một câu đoán.',
  'ask.label': 'Câu hỏi',
  'ask.placeholder': 'Quy trình deploy hoạt động thế nào?',
  'ask.submit': 'Hỏi với {credits} credit',
  'ask.asking': 'Đang hỏi…',
  'ask.cost': 'Dùng nhà cung cấp AI của bạn. {credits} credit mỗi câu trả lời; không tốn gì khi wiki không có câu trả lời hoặc nhà cung cấp lỗi.',
  'ask.failed': 'Không hỏi được: {message}',
  'ask.notFound': 'Wiki không có câu trả lời.',
  'ask.notFoundHint': 'Không bị trừ credit. Hãy đẩy một Nguồn trả lời được rồi biên soạn; câu hỏi này được liệt kê ở mục Sức khỏe.',
  'ask.providerFailed': 'Nhà cung cấp AI lỗi: {message}. Không bị trừ credit.',
  'ask.citations': 'Trích dẫn',
  'ask.kind.wiki': 'Wiki',
  'ask.kind.source': 'Nguồn',
  'ask.kind.document': 'Tài liệu',
  'ask.charged': 'Đã trừ {credits} credit',
  'ask.needsEditor': 'Hỏi wiki tốn credit của workspace, nên chỉ vai trò Biên tập hoặc Quản trị mới hỏi được.',
}
